exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mailTo{color:#fff}#modal-1___BV_modal_content_{margin-top:50%;color:#fff;background-color:rgba(128,0,0,.7)!important}.container{height:100%;align-content:center}.input-group-prepend span{width:50px;background-color:#e0e4cc;color:#000;border:0!important}b-form-input:focus{outline:0!important;box-shadow:0 0 0 0!important}.login_btn{color:#000;background-color:#e0e4cc;margin:20px;width:100px}.login_btn:hover{color:#000;background-color:#fff}#forgottenPassword{padding:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f001c28","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/commons/LoginPage.vue
// module id = 649
// module chunks = 0